import globalAPI from "@/api/accounts";

const getDefaultState = () => ({
  crmUsers: [],
  crmUsersLoading: false,
  crmUsersError: false,
  crmUsersErrorMsg: null
});

const state = getDefaultState();

const mutations = {
  SET_USERS_LOADING() {
    state.crmUsersLoading = true;
    state.crmUsersError = false;
    state.crmUsersErrorMsg = null;
  },

  SET_USERS(state, payload) {
    state.crmUsers = payload;
    state.crmUsersLoading = false;
  },

  SET_USERS_ERROR(state, err) {
    state.crmUsersLoading = false;
    state.crmUsersError = true;
    state.crmUsersErrorMsg = err;
  },

  RESET_CRM_USERS(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchCRMUsers({ state, commit }) {
    commit("SET_USERS_LOADING");
    try {
      if(state.crmUsers.length > 0) {
        commit("SET_USERS", state.crmUsers);
      } else {
        const response = await globalAPI.getCRMUsers();
        commit("SET_USERS", response.data);
      }
    } catch(err) {
      commit("SET_USERS_ERROR", err.response);
    }
  },
};

const getters = {
  getCrmUsersForSelect: (state) => {
    return state.crmUsers.map(e=>{return e.sid; }).sort();
  },
  getCrmUsers: (state) => {
    return state.crmUsers.sort((a, b) => a.long_name.localeCompare(b.long_name));;
  },
  getCrmUsersLoading: state => state.crmUsersLoading,
  getCrmUsersError: state => state.getCrmUsersError,
  getCrmUsersErrorMsg: state => state.getCrmUsersErrorMsg,
  getTeamByRoles: (state) => roles => {
    return state.crmUsers.reduce((acc, obj) => { 
      obj.roles.forEach(j => {
        if(roles.includes(j.sid)) {
          acc.push({ text: obj.sid, value: obj.sid, long_name: obj.long_name });
        }
      });
      return acc;
    }, []);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
